export default __webpack_public_path__ + "static/media/Shipping.f49a568a.jpg";